function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "url(#pattern0)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_5263_27919",
  transform: "scale(0.0104167)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_5263_27919",
  width: 96,
  height: 96,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADCElEQVR4nO3cz2rUUBTH8a9/FoJWoaC1MgNupL6CL6BSioIUX0AQ1HdRXOpSEEGKC6muXPgMuii6UamioEUy4v8Z6iKl4DR/7s1NenKT3weyaXJyb85pJvdmMgEREREREREREREREREREemqPZ7bD4CLwBJwEhgCB+vuVGS+A+vAG2AVeAy8r7uRo8Bt4C+wqaVwmQD3gPlKmc6wBCQtOLDYlgRYrJDv/1wHxi04mFiXMXDNO+tbzqPk17FMSD9FMuVdhE8Aa8DhvEDxkgCngU/TK/blBNwEzjTZo545ABwCnkyvyDoDBqRDqv0Nd6pvxqRD9w9lG96g/HNtHVgGZhrqbExmgEvAa8rz5nRBflqyk3Vgts4j6IhZ0glYUe5WXXb0qmQnyzV3vEsuU5y7NZedjEp2oo+dfEcozt1oOiDrIrxZ0ojv/aO+8crf3gY7Ig5UAGMqgDEVINsQWCG9aI6AR8DCbjVeNpnouiGwwc7j3iC9S1AmOH99L8AK+cf+0CFeBQhUNA9KHOK98qd5wE6hx695QExUAGMqgLG2FsB0HG7NehQUOg4PFXr80Q9DQ8fhoXpfgNBxeKhdLUAb5wGxt695QExUAGMqgLGuFiDqeYT1KCi0fev7+dEPQ0Pbt76f3/th6Ij8Z5dGpM/uNNm+V3wXCxBVfFcvwtFQAYypAMayCvCjhv1GPQ5vkFNu39HvcXiT8W+nN846A146NFLkFtk/4Jgl/e1Zn72Y/kNWAZ4HNnK2YN25wH3Hzim388Af2nkKxxz/Gzg+vXHWGfAReODQkPi5T8bvhPPMAV9p139QzPEJFV7esUj2qwqqdKDP8RPSV/xUcpWdRfDtgHUCLOPHwBWHmEIXgC8VO2CdAMv4zxS8pMPXMeAu8MujA9YJsIr/CdwhfclV7eYctrFOgHW8S462NXFvv6yTrbof30C8F90NNaYCGFMBjDVRgG8F61wero093ksTBXhWcV1X4s0tkP+FzKkexLfCgPQhqGRrWcGv87HHi4iIiIiIiIiIiIiIbPsHyGYl2CxphSAAAAAASUVORK5CYII="
}));

function SvgPowerBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBi);
export default __webpack_public_path__ + "static/media/power-bi.91a21636.svg";
export { ForwardRef as ReactComponent };